import React from 'react';
import { errorReporter } from '../services/errorReporter';

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class AppErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    if (info.componentStack) {
      errorReporter.addBreadcrumb('react.componentStack', {
        componentStack: info.componentStack.slice(0, 256),
      });
    }
    errorReporter.report(error, 'critical').catch(() => undefined);
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div role="alert" style={{ padding: 16 }}>
            <h2>Something went wrong.</h2>
            <p>Please reload the app. The team has been notified.</p>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
